<template>
  <div class="upload-file">
    <div class="preview-file-row">
      <span :data-cy="'name-'+ typeFile" class="centrado">{{ file ? file.name : "" }}</span>
    </div>
    <div class="upload-file-row">
      <q-file
        :data-cy ="'file-input-' + typeFile"
        :accept="accept"
        @rejected="onRejected"
        :max-file-size="maxFileSize()"
        standout
        dense
        max-files="1"
        :multiple="false"
        bg-color="primary"
        input-class="inputStyle"
        v-model="file.file"
        @input="refreshFileInfo()"
        :display-value="labelFile"
        :loading="isLoading">
        <template v-slot:prepend>
          <q-icon class="upload-icon" :name="'img:' + require('@/assets/img/upload-outline.svg')" />
        </template>
      </q-file>
      <q-btn
      :data-cy ="'btn-delete-' + typeFile"
      class="btnDeleteFile"
      icon="delete"
      color="primary"
      unelevated
      @click="deleteFile()"
      :label="labelDeleteFile"></q-btn>
    </div>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
export default {
  mixins: [Message],
  props: {
    label: String,
    labelDeleteFile: String,
    value: {
      required: true
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: () => false
    },
    accept: String,
    fileSize: {
      required: true,
      type: Number
    },
    typeFile: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      file: {
        file: null,
        name: ''
      },
      isUploading: false,
      labelFile: this.label,
      updateVideo: false
    };
  },
  watch: {
    value: {
      handler: function () {
        this.file = this.value;
        if (!this.value.hasOwnProperty('name')) {
          this.file.name = this.value.originalFileName;
        }
      },
      immediate: true
    }
  },
  methods: {
    refreshFileInfo () {
      this.updateFile = true;
      this.file.name = this.file.file.name;
      this.$emit('input', this.file);
    },
    deleteFile () {
      this.$emit('deleteFile');
    },
    onRejected () {
      if (this.accept === 'pdf') {
        this.showError(`No es un fichero válido, debe ser .pdf y tamaño máximo 10MB`);
      } else if (this.accept === 'video/mp4') {
        this.showError(`No es un fichero válido, debe ser .video/mp4 y tamaño máximo 450MB`);
      }
    },
    maxFileSize () {
      return this.fileSize;
    }
  }
};
</script>
<style lang="scss" scoped>
.upload-file {
  padding: 20px;
  width: 250px;
  position: absolute;
  bottom: 0;
  .preview-file-row {
    padding: 16px 0px;
    width: 100%;
    overflow: hidden;
    word-wrap: break-word;
    word-break: word;
    text-overflow: ellipsis;
    .centrado {
      display: block;
      margin-left: auto;
      margin-right: auto;
      padding: 8px;
    }
  }
  .upload-file-row {
    padding: 25px 0px 40px 0px;
    margin-left: auto;
    margin-right: auto;

    .upload-icon {
      font-size: 24px;
      margin-left: 4px;
      filter: invert(100%) sepia(100%) saturate(38%) hue-rotate(254deg)
        brightness(110%) contrast(110%);
    }
  }

  &:deep() {
    .inputStyle {
      margin: auto;
      color: white;
      font-size: 12px;
      font-weight: bold;
    }

    .q-field__control {
      background: $seafoam-blue !important;
    }
    .btnDeleteFile {
      height: 40px;
      margin-top: 5px;
      width: 100%;
      margin-left: 0px !important;
      .q-btn__content {
        font-size: 12px;
      }
      span.block {
        width: 75%;
      }
      .q-icon{
        margin-right: 20px;
      }
    }
  }
}
</style>
